import { Button } from "components/button/Button/Button";
import React from "react";
import { StyledDialogFooter } from "./style";
import { useDialogContext } from "../controller/DialogProvider";
import { Icons } from "contents/icons";
import { useDialogOverlayContext } from "../controller/DialogOverlay";

interface DialogFooterProps {
  button?: {
    label?: string;
    preIcon?: keyof typeof Icons;
    postIcon?: keyof typeof Icons;
    disabled?: boolean;
    width?: string;
    offAutoClose?: boolean;
    onClick?: (
      e: React.MouseEvent<HTMLButtonElement>
    ) => Promise<boolean> | void;
  };
  secondButton?: {
    label?: string;
    preIcon?: keyof typeof Icons;
    postIcon?: keyof typeof Icons;
    disabled?: boolean;
    width?: string;
    onClick?: (
      e: React.MouseEvent<HTMLButtonElement>
    ) => Promise<boolean> | void;
  };
}

export const DialogFooter = ({ button, secondButton }: DialogFooterProps) => {
  const { closeDialog } = useDialogContext();
  const { $size, $state } = useDialogOverlayContext();

  return (
    <StyledDialogFooter>
      {secondButton && (
        <Button
          color="primary"
          type="outline"
          width={
            secondButton.width
              ? secondButton.width
              : $size === "small"
                ? "8rem"
                : "12rem"
          }
          size={$size === "small" ? "medium" : "large"}
          label={secondButton.label}
          disabled={secondButton.disabled}
          onClick={async (e) => {
            const breakClose =
              secondButton.onClick && (await secondButton.onClick(e));
            if (breakClose) return;
            closeDialog();
          }}
        />
      )}
      {button && (
        <Button
          color="primary"
          type="solid"
          width={
            button.width ? button.width : $size === "small" ? "8rem" : "12rem"
          }
          size={$size === "small" ? "medium" : "large"}
          label={button.label}
          disabled={button.disabled}
          onClick={async (e) => {
            const breakClose =
              (button.onClick && (await button.onClick(e))) ||
              button.offAutoClose;
            if (breakClose) return;
            closeDialog();
          }}
        />
      )}
    </StyledDialogFooter>
  );
};
